import { serverMediatedPage } from '../../shared/reading_request';
import PromptComposerTools from './prompt_composer_tools';
import { vocabListItemHtml } from './vocab_list_item';
import SpeakApiClient from './speak_api_client';
import ActivityCompletionList from './activity_completion_list';

class ChatTopicService {
  constructor(chatElementContainer, chatElement) {
    this.chatElementContainer = chatElementContainer;
    this.chatElement = chatElement;
    this.topics = null;
    const completionApi = new SpeakApiClient(chatElement.dataset.authToken);
    this.activityCompletion = new ActivityCompletionList(chatElement, language => completionApi.getActivityHistories(language));
    this.userId = this.chatElementContainer.querySelector('.chat-content').dataset.userId;

    // Explicit navigation stack for the Browse drilldown. Each frame is a
    // replay descriptor for the click that opened a level ({main} for a
    // category, {sub} for a sub-category). Back = replay the stack minus its
    // top frame, which re-runs the real click handlers (help texts, version
    // toggles, etc.) instead of guessing depth from DOM contents.
    this.navStack = [];
    this.replayingNav = false;
    this.bindNavigation();
  }

  bindNavigation() {
    const service = this;

    $(document)
      .off('click.chatNav', '.js-main-chat-option-btn')
      .on('click.chatNav', '.js-main-chat-option-btn', function () {
        if (service.replayingNav) return;
        service.navStack = [{ main: String($(this).data('topic-category')) }];
        service.syncBackRow();
      });

    $(document)
      .off('click.chatNav', '.js-sub-category-btn')
      .on('click.chatNav', '.js-sub-category-btn', function () {
        if (service.replayingNav) return;
        const sub = $(this).data('subtopic-category');
        if (sub === undefined || sub === null) return;
        service.navStack.push({ sub: String(sub) });
        service.syncBackRow();
      });

    $('body')
      .off('click.chatTopicBack', '.js-chat-form-back-button')
      .on('click.chatTopicBack', '.js-chat-form-back-button', function (e) {
        e.preventDefault();
        service.goBack();
      });

    this.syncBackRow();
  }

  // Plain-name transcription hint for dictation ("english (american)" →
  // "english"), read from the speak page config. '' lets the server auto-detect.
  nativeLanguageHint() {
    try {
      const configEl = this.chatElement.querySelector('.js-speak-page-config');
      const config = configEl ? JSON.parse(configEl.textContent || '{}') : {};
      return String(config.native_language || '').replace(/\(.*?\)/g, '').trim().toLowerCase();
    } catch (_) {
      return '';
    }
  }

  // LAN-824: 'not_asked' | 'enabled' | 'disabled' from the speak page config.
  // The one-time sharing opt-in is offered only while 'not_asked'.
  promptSharingStatus() {
    try {
      const configEl = this.chatElement.querySelector('.js-speak-page-config');
      const config = configEl ? JSON.parse(configEl.textContent || '{}') : {};
      return String(config.prompt_sharing_status || 'not_asked');
    } catch (_) {
      return 'not_asked';
    }
  }

  syncBackRow() {
    $('.js-mobile-subview-back-row')
      .toggleClass('d-none', this.navStack.length === 0)
      .toggleClass('d-flex', this.navStack.length > 0);
  }

  navButtonFor(frame) {
    const escape = window.CSS && CSS.escape ? CSS.escape : (v) => v.replace(/["\\]/g, '\\$&');
    if (frame.main !== undefined) {
      return document.querySelector(`.js-main-chat-option-btn[data-topic-category="${escape(frame.main)}"]`);
    }
    return document.querySelector(`.js-sub-category-btn[data-subtopic-category="${escape(frame.sub)}"]`);
  }

  goBack() {
    const parentFrames = this.navStack.slice(0, -1);
    this.navStack = [];
    // Both branches leave the current view. The replay branch re-clicks a
    // category button whose handler lives in chat_service.js and re-renders
    // via showSubCategories, so an open dictation would otherwise keep the
    // mic, recorder and timers alive until the composer is next re-created.
    this.destroyComposerTools();

    if (parentFrames.length === 0) {
      const container = $('.js-sub-options-container');
      container.empty().removeClass('scroll-options is-custom-prompt-view');
      this.updateSubOptionsVisibility(container);
      this.showChatTopics();
      this.syncBackRow();
      // chat_form.js listens: resets guided-course state and subview classes.
      document.dispatchEvent(new CustomEvent('chat:nav-top'));
      return;
    }

    this.replayingNav = true;
    try {
      parentFrames.forEach(frame => this.navButtonFor(frame)?.click());
    } finally {
      this.replayingNav = false;
    }
    this.navStack = parentFrames;
    this.syncBackRow();
  }

  updateSubOptionsVisibility(container) {
    if (container.children().length > 0) {
      container.show().removeClass('d-none');
    } else {
      container.hide().addClass('d-none');
    }
  }

  showSubCategories(topicCategory, subCategories, container, currentLabel = null) {
    // Like addCategoryContent / showChatTopics: never re-render over live tools.
    this.destroyComposerTools();
    container.empty().removeClass('scroll-options is-custom-prompt-view');

    subCategories.forEach(subCategory => {
      let divHtml = $(`<div class="col-12 col-md-6 col-lg-4 chat-topic-button-col"></div>`);
      const buttonHtml = $(`<button type="button" class="btn btn-secondary-cta-outline chat-topic-button py-3 chat-option-button w-100 mb-2" data-topic-category="${topicCategory}" data-subtopic-category="${subCategory.key}" data-topics="${JSON.stringify(subCategory.topics === undefined ? null : subCategory.topics).replace(/"/g, '&quot;')}">${subCategory.label}</button>`);

      if (subCategory.key === 'generate_random_interests_title') {
        buttonHtml.addClass('js-generate-topic-titles-btn');
      } else {
        if (subCategory.key === 'generate_your_interest') {
          buttonHtml.addClass('js-generate-interest-btn')
        }

        buttonHtml.addClass('js-sub-category-btn');
      }

      if (subCategory.key === 'grammar_explanation') {
        // grammarConcept is the canonical (English) topic — used to request the explanation.
        const grammarConcept = topicCategory.split('/').pop();
        // Display the localized label when available; fall back to the English topic.
        const grammarLabel = currentLabel || grammarConcept;
        buttonHtml[0].innerText += grammarLabel;
        buttonHtml.data('grammarTopic', grammarConcept);
        buttonHtml.data('grammarTopicLabel', grammarLabel);
        buttonHtml.removeClass('js-sub-category-btn');
        buttonHtml.addClass('js-grammar-explanation-btn');
      }

      if (topicCategory === 'debate') {
        container.addClass('scroll-options');
      }

      divHtml.append(buttonHtml);
      container.append(divHtml);
    });

    this.activityCompletion.render();
    this.updateSubOptionsVisibility(container);
    $('.js-chat-form-back-button').removeClass('d-none');

    this.hideChatTopics();
  }

  showSubOptions(topicCategory, subtopicCategory, topics) {
    this.topics = topics;
    const container = $('.js-sub-options-container');
    container.empty().removeClass('is-custom-prompt-view');

    topics.forEach(topic => {
      const buttonHtml = `<div class="col-12 col-md-6 col-lg-4 chat-topic-button-col">
        <button type="button" class="btn btn-secondary-cta-outline chat-topic-button py-3 chat-option-button w-100 mb-2 js-sub-chat-option-btn"
          data-topic="${topic.key.replace(/"/g, '&quot;')}" data-topic-category="${topicCategory.replace(/"/g, '&quot;')}" data-subtopic-category="${subtopicCategory.replace(/"/g, '&quot;')}">
          ${topic.label}
        </button>
      </div>`;
      container.append(buttonHtml);
    });

    this.activityCompletion.render();
    this.updateSubOptionsVisibility(container);
  }

  // The composer tools hold the microphone; release it whenever the markup
  // that owns them is emptied or replaced (navigation, view re-render).
  destroyComposerTools() {
    if (this.createComposerTools) {
      this.createComposerTools.destroy();
      this.createComposerTools = null;
    }
    if (this.editComposerTools) {
      this.editComposerTools.destroy();
      this.editComposerTools = null;
    }
  }

  addCategoryContent(topicCategory, container, generated_topic = null, userPrompts) {
    this.destroyComposerTools();
    container.empty().toggleClass('is-custom-prompt-view', topicCategory === 'custom_conversation');
    let containerContent = ''

    if (topicCategory === 'my_interests') {
      containerContent = `<div class="p-3">
        <strong>
          ${I18n.t('javascript.chat.my_interests_message_html', { user_id: this.userId })}
        </strong>
      </div>`;
    } else if (topicCategory === 'generated_interest') {
      containerContent = `<div class="col-12 col-md-4 col-lg-4 col-xl-5">
                            <button type="button" 
                              class="btn btn-secondary-cta-outline py-3 w-100 js-generate-topic-titles-btn" 
                              data-topic-category=${JSON.stringify(generated_topic)}
                              data-subtopic-category="generate_random_interests_title"
                              data-topics='${JSON.stringify(null)}'>
                              ${I18n.t('javascript.chat.generate_discussions_about', { topic: generated_topic.toLowerCase() })}
                            </button>
                          </div>`;
    } else if (topicCategory === 'generate_your_interest') {
      containerContent = `<div class="col-12 col-md-4 col-lg-4 col-xl-5">
                            <div class="form-group mb-3">
                              <input type="text" 
                                class="form-control js-custom-interest-input dark-placeholder" 
                                maxlength="30" 
                                placeholder="${I18n.t('javascript.chat.enter_interest_placeholder')}"
                                aria-label="Custom interest input">
                              <small class="text-muted js-char-count">${I18n.t('javascript.chat.char_count', { count: 0, max: 30 })}</small>
                            </div>
                            <button type="button" 
                              class="btn btn-secondary-cta-outline py-3 w-100 js-generate-topic-titles-btn" 
                              disabled
                              data-topic-category=""
                              data-subtopic-category="generate_random_interests_title"
                              data-topics='${JSON.stringify(null)}'>
                              ${I18n.t('javascript.chat.generate_discussions')}
                            </button>
                          </div>`;
    } else if (topicCategory === 'custom_conversation') {
      containerContent = `<div class="col-12 col-md-10">
                            <strong>
                              ${I18n.t('javascript.chat.enter_custom_prompt')}
                            </strong>
                            <div class="mb-2">
                              <a href="#" class="js-custom-conversation-tips-link"><i class="fa fa-question-circle" aria-hidden="true"></i> ${I18n.t('javascript.chat.see_tips_link')}</a>
                            </div>
                            <div class="js-custom-conversation-tips-modal modal fade" tabindex="-1" role="dialog" aria-hidden="true">
                              <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <h5 class="modal-title">${I18n.t('javascript.chat.tips_modal_title')}</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body">
                                    <p>${I18n.t('javascript.chat.tips_paragraph_1')}</p>
                                    <p>${I18n.t('javascript.chat.tips_paragraph_2')}</p>
                                    <p>${I18n.t('javascript.chat.tips_paragraph_3')}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group mb-3">
                              <textarea type="text" 
                                class="form-control js-custom-conversation-prompt dark-placeholder" 
                                maxlength="20000" 
                                placeholder="${I18n.t('javascript.chat.type_here')}"
                                style="min-height: 300px; color: #000;"></textarea>
                              <div class="d-flex justify-content-between align-items-center">
                                <small class="text-muted js-char-count">${I18n.t('javascript.chat.char_count', { count: 0, max: 20000 })}</small>
                              </div>
                            </div>
                            <div class="js-prompt-composer-tools"></div>
                            <div class="mb-3 prompt-share-consent js-prompt-share-consent-row" style="display: none;">
                              <div class="d-flex align-items-start">
                                <div class="custom-control custom-checkbox">
                                  <input type="checkbox" class="custom-control-input js-custom-conversation-share-consent" id="js-custom-conversation-share-consent">
                                  <label class="custom-control-label" for="js-custom-conversation-share-consent">${I18n.t('javascript.chat.share_consent_label')}</label>
                                </div>
                                <button type="button" class="btn btn-link p-0 ml-2 prompt-share-consent-info-toggle js-prompt-share-consent-info-toggle" aria-expanded="false" aria-controls="js-prompt-share-consent-info" aria-label="${I18n.t('javascript.chat.share_consent_more_info')}"><i class="fa fa-question-circle" aria-hidden="true"></i></button>
                              </div>
                              <small class="text-muted prompt-share-consent-info js-prompt-share-consent-info" id="js-prompt-share-consent-info" style="display: none;">${I18n.t('javascript.chat.share_consent_info')}</small>
                            </div>
                            <div class="form-group mb-3">
                              <input type="text" 
                                class="form-control js-custom-conversation-title dark-placeholder" 
                                maxlength="50" 
                                placeholder="${I18n.t('javascript.chat.label_your_prompt')}"
                                style="color: #000;">
                              <small class="text-muted js-char-count">${I18n.t('javascript.chat.char_count', { count: 0, max: 50 })}</small>
                            </div>
                            <button type="button" 
                              class="btn mt-3 btn-secondary-cta-outline py-3 js-generate-custom-conversation-btn" 
                              style="width: 50%; margin: 0 auto; display: block;"
                              disabled
                              data-topic-category="custom_conversation"
                              data-subtopic-category="create_new"
                              data-topic="custom_conversation">
                              ${I18n.t('javascript.chat.start_chat')}
                            </button>
                          </div>`;
    } else if (topicCategory === 'my_prompts') {
      const esc = (s) => String(s ?? '')
        .replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
        .replace(/</g, '&lt;').replace(/>/g, '&gt;');
      containerContent = `
        <div class="col-12">
          <h4 class="mb-2">${I18n.t('javascript.chat.my_prompts')}</h4>
          <p class="mb-4">${I18n.t('javascript.chat.my_prompts_description')}</p>
          
          <div class="row mb-4">
            <div class="col-md-8">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text bg-light border-right-0">
                    <i class="fa fa-search text-muted"></i>
                  </span>
                </div>
                <input type="text" class="form-control border-left-0 js-prompt-search" placeholder="${I18n.t('javascript.chat.search_by_label_or_prompt')}" style="font-weight: 400">
              </div>
            </div>
            <div class="col-md-4">
              <select class="form-control js-prompt-sort">
                <option value="last_used_at" selected>${I18n.t('javascript.chat.sort_last_used')}</option>
                <option value="created_at">${I18n.t('javascript.chat.sort_created_date')}</option>
                <option value="title">${I18n.t('javascript.chat.sort_alphabetical')}</option>
              </select>
            </div>
          </div>

          <div class="js-prompts-container" style="max-height: 70vh; overflow-y: auto;">
            ${userPrompts.map(prompt => `
              <div class="prompt-item mb-3 p-3 cursor-pointer" style="border-radius: 1rem"
                data-created-at="${prompt.created_at}" 
                data-last-used-at="${prompt.last_used_at || ''}"
                data-title="${esc(prompt.title.toLowerCase())}"
                data-prompt="${esc(prompt.prompt.toLowerCase())}"
                data-prompt-id="${prompt.id}"
                data-prompt-title="${esc(prompt.title)}"
                data-custom-prompt="${esc(prompt.prompt)}">
                <div class="d-flex justify-content-between align-items-start">
                  <p class="mb-2" style="font-size: 1rem; font-weight: 600;">${esc(prompt.title)}</p>
                  <div class="prompt-actions">
                    <button class="btn btn-link p-0 mr-2 js-edit-prompt-title" data-prompt-id="${prompt.id}" data-title="${esc(prompt.title)}">
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button class="btn btn-link p-0 text-danger js-delete-prompt" data-prompt-id="${prompt.id}" data-title="${esc(prompt.title)}">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
                <p class="mb-0">${esc(prompt.prompt.substring(0, 100))}${prompt.prompt.length > 100 ? '...' : ''}</p>
              </div>
            `).join('')}
          </div>
        </div>

        <!-- Edit Title Modal -->
        <div class="modal fade" id="editPromptTitleModal" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">${I18n.t('javascript.chat.edit_prompt')}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group mb-3">
                  <label>${I18n.t('javascript.chat.label_title')}</label>
                  <input type="text" class="form-control js-edit-title-input" maxlength="50">
                  <small class="text-muted js-title-char-count">${I18n.t('javascript.chat.char_count', { count: 0, max: 50 })}</small>
                </div>
                <div class="form-group">
                  <label>${I18n.t('javascript.chat.label_prompt')}</label>
                  <textarea class="form-control js-edit-prompt-input" maxlength="20000" rows="10"></textarea>
                  <small class="text-muted js-prompt-char-count">${I18n.t('javascript.chat.char_count', { count: 0, max: 20000 })}</small>
                </div>
                <div class="js-edit-prompt-composer-tools"></div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">${I18n.t('shared.buttons.cancel')}</button>
                <button type="button" class="btn btn-primary js-save-title">${I18n.t('shared.buttons.save')}</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Delete Confirmation Modal -->
        <div class="modal fade" id="deletePromptModal" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">${I18n.t('javascript.chat.delete_prompt')}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <p>${I18n.t('javascript.chat.delete_prompt_confirm')}</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">${I18n.t('shared.buttons.cancel')}</button>
                <button type="button" class="btn btn-danger js-confirm-delete">${I18n.t('shared.buttons.delete')}</button>
              </div>
            </div>
          </div>
        </div>
      `;

      setTimeout(() => {
        $('.js-prompt-search').on('input', function() {
          const searchTerm = $(this).val().toLowerCase();
          $('.prompt-item').each(function() {
            const title = $(this).data('title');
            const prompt = $(this).data('prompt');
            const matches = title.includes(searchTerm) || prompt.includes(searchTerm);
            $(this).toggle(matches);
          });
        });

        $('.js-prompt-sort').on('change', function() {
          const sortBy = $(this).val();
          const container = $('.js-prompts-container');
          const items = container.find('.prompt-item').toArray();

          items.sort((a, b) => {
            if (sortBy === 'created_at' || sortBy === 'last_used_at') {
              // Get the raw date strings from data attributes
              const dateStrA = $(a).attr(`data-${sortBy.replace(/_/g, '-')}`);
              const dateStrB = $(b).attr(`data-${sortBy.replace(/_/g, '-')}`);
              
              // If either date is empty, sort it to the end
              if (!dateStrA) return 1;
              if (!dateStrB) return -1;
              
              // Parse the dates
              const dateA = new Date(dateStrA);
              const dateB = new Date(dateStrB);
              
              // Sort most recent first
              return dateB.getTime() - dateA.getTime();
            } else if (sortBy === 'title') {
              const titleA = $(a).data('title').toLowerCase();
              const titleB = $(b).data('title').toLowerCase();
              return titleA.localeCompare(titleB);
            }
          });

          container.empty().append(items);
        });

        let currentPromptId = null;

        // Dictate / Enhance / Clear under the edit modal's prompt field (LAN-716/717).
        // Save waits while dictating/enhancing/previewing and while the prompt
        // is over the 20,000-character limit (`.val()` bypasses maxlength).
        let editComposerBusy = false;
        const syncSaveButton = () => {
          const promptLength = ($('.js-edit-prompt-input').val() || '').length;
          $('.js-save-title').prop('disabled', editComposerBusy || promptLength === 0 || promptLength > 20000);
        };
        const editComposerTools = new PromptComposerTools({
          mount: $('.js-edit-prompt-composer-tools')[0],
          textarea: $('.js-edit-prompt-input')[0],
          source: 'edit',
          nativeLanguage: this.nativeLanguageHint(),
          onBusyChange: (busy) => {
            editComposerBusy = busy;
            syncSaveButton();
          },
        });
        this.editComposerTools = editComposerTools;
        $('.js-edit-prompt-input').on('input', syncSaveButton);
        // Closing the modal (X, Cancel, backdrop) stops any recording and
        // discards an in-flight transcript so it cannot land in another prompt.
        $('#editPromptTitleModal').on('hidden.bs.modal', () => editComposerTools.reset());
        
        $('.js-prompts-container').on('click', '.js-edit-prompt-title', function(e) {
          e.stopPropagation();
          currentPromptId = $(this).data('prompt-id');
          const promptItem = $(`.prompt-item[data-prompt-id="${currentPromptId}"]`);
          const currentTitle = promptItem.find('p.mb-2').text();
          const currentPrompt = promptItem.data('custom-prompt');
          
          editComposerTools.reset();
          $('.js-edit-title-input').val(currentTitle);
          $('.js-edit-prompt-input').val(currentPrompt).trigger('input');
          
          $('.js-title-char-count').text(I18n.t('javascript.chat.char_count', { count: currentTitle.length, max: 50 }));
          $('.js-prompt-char-count').text(I18n.t('javascript.chat.char_count', { count: currentPrompt.length, max: 20000 }));
          
          $('#editPromptTitleModal').modal('show');
        });

        let promptToDelete = null;
        $('.js-prompts-container').on('click', '.js-delete-prompt', function(e) {
          e.stopPropagation();
          promptToDelete = $(this).data('prompt-id');
          $('#deletePromptModal').modal('show');
        });

        $('.js-edit-title-input').on('input', function() {
          const length = $(this).val().length;
          $(this).siblings('.js-title-char-count').text(I18n.t('javascript.chat.char_count', { count: length, max: 50 }));
        });

        $('.js-edit-prompt-input').on('input', function() {
          const length = $(this).val().length;
          $(this).siblings('.js-prompt-char-count').text(I18n.t('javascript.chat.char_count', { count: length, max: 20000 }));
        });

        $('.js-save-title').on('click', function() {
          const newTitle = $('.js-edit-title-input').val();
          const newPrompt = $('.js-edit-prompt-input').val();
          
          if (newTitle.trim()) {
            $.ajax({
              url: `/langua/user_prompts/${currentPromptId}`,
              method: 'PATCH',
              data: { 
                user_prompt: { 
                  title: newTitle,
                  prompt: newPrompt
                } 
              },
              success: function() {
                const promptItem = $(`.prompt-item[data-prompt-id="${currentPromptId}"]`);
                promptItem.find('p.mb-2').text(newTitle);
                promptItem.data('title', newTitle.toLowerCase());
                promptItem.data('prompt', newPrompt.toLowerCase());
                promptItem.data('prompt-title', newTitle);
                promptItem.data('custom-prompt', newPrompt);

                const previewText = newPrompt.substring(0, 100) + (newPrompt.length > 100 ? '...' : '');
                promptItem.find('p.mb-0').text(previewText);
                
                $('#editPromptTitleModal').modal('hide');
              },
              error: function(xhr) {
                alert(I18n.t('javascript.alerts.error_updating_prompt', { error: xhr.responseJSON.error }));
              }
            });
          }
        });

        $('.js-confirm-delete').on('click', function() {
          if (promptToDelete) {
            $.ajax({
              url: `/langua/user_prompts/${promptToDelete}`,
              method: 'DELETE',
              success: function() {
                $(`.prompt-item[data-prompt-id="${promptToDelete}"]`).remove();
                $('#deletePromptModal').modal('hide');
              },
              error: function(xhr) {
                alert(I18n.t('javascript.alerts.error_deleting_prompt', { error: xhr.responseJSON.error }));
              }
            });
          }
        });

        // Add click handler for prompt items
        $('.js-prompts-container').on('click', '.prompt-item', function(e) {
          if ($(e.target).closest('.prompt-actions').length) {
            return;
          }

          const promptItem = $(this);
          const promptTitle = promptItem.data('prompt-title');
          const customPrompt = promptItem.data('custom-prompt');

          $('#js-chat-custom-prompt-title').val(promptTitle);
          $('#js-chat-custom-prompt').val(customPrompt);
          $('#js-chat-topic').val('custom_conversation');
          $('#js-chat-topic-category').val('custom_conversation');
          $('#js-chat-subtopic-category').val('create_new');
          // LAN-824: sharing is account-level; reuse sends no opt-in (blank = unchanged).
          $('#js-chat-custom-prompt-share-consent').val('');

          $('#new-chat-form').submit();
        });
      }, 0);
    }

    container.append(containerContent);

    this.updateSubOptionsVisibility(container);

    // Add input listener if we're in generate_your_interest mode
    if (topicCategory === 'generate_your_interest') {
      const input = container.find('.js-custom-interest-input');
      const generateButton = container.find('.js-generate-topic-titles-btn');
      const charCount = container.find('.js-char-count');

      input.on('input', function () {
        const length = $(this).val().length;
        let interestValue = $(this).val();

        charCount.text(I18n.t('javascript.chat.char_count', { count: length, max: 30 }));

        generateButton.prop('disabled', length === 0);

        // Update the button's data attribute with the current input
        generateButton.attr('data-topic-category', interestValue);
      });
    };
    
    // Add input listeners for custom conversation mode
    if (topicCategory === 'custom_conversation') {
      const promptTextarea = container.find('.js-custom-conversation-prompt');
      const titleInput = container.find('.js-custom-conversation-title');
      const generateButton = container.find('.js-generate-custom-conversation-btn');
      const promptCharCount = promptTextarea.closest('.form-group').find('.js-char-count');
      const titleCharCount = titleInput.siblings('.js-char-count');
      
      // Dictation / enhancement / preview in progress: Start chat waits.
      let composerBusy = false;

      const updateButtonState = function() {
        const promptLength = promptTextarea.val().length;
        const titleLength = titleInput.val().length;
        
        promptCharCount.text(I18n.t('javascript.chat.char_count', { count: promptLength, max: 20000 }));
        titleCharCount.text(I18n.t('javascript.chat.char_count', { count: titleLength, max: 50 }));
        
        generateButton.prop('disabled', promptLength === 0 || promptLength > 20000 || titleLength === 0 || composerBusy);
        
        generateButton.attr('data-prompt-title', titleInput.val());
        generateButton.attr('data-custom-prompt', promptTextarea.val());
        // LAN-824: the one-time sharing opt-in is offered only on a substantial new
        // prompt (200+ characters, whitespace included) while the account is
        // not_asked. Unticked by default, never blocks Start chat. chat_form.js
        // copies data-share-consent into the form: '1' = opted in, '' = no opinion.
        const offerSharing = sharingStatus === 'not_asked' && promptLength >= SHARE_CONSENT_MIN_CHARS;
        shareConsentRow.toggle(offerSharing);
        const optedIn = offerSharing && shareConsentBox.is(':checked');
        generateButton.attr('data-share-consent', optedIn ? '1' : '');
      };
      const SHARE_CONSENT_MIN_CHARS = 200;
      const sharingStatus = this.promptSharingStatus();
      const shareConsentRow = container.find('.js-prompt-share-consent-row');
      const shareConsentBox = container.find('.js-custom-conversation-share-consent');
      shareConsentBox.on('change', updateButtonState);
      container.find('.js-prompt-share-consent-info-toggle').on('click', function() {
        const info = container.find('.js-prompt-share-consent-info');
        const open = !info.is(':visible');
        info.toggle(open);
        $(this).attr('aria-expanded', open ? 'true' : 'false');
      });
      
      promptTextarea.on('input', updateButtonState);
      titleInput.on('input', updateButtonState);

      // Dictate / Enhance / Clear under the prompt field (LAN-716/717).
      this.createComposerTools = new PromptComposerTools({
        mount: container.find('.js-prompt-composer-tools')[0],
        textarea: promptTextarea[0],
        source: 'create',
        nativeLanguage: this.nativeLanguageHint(),
        onBusyChange: (busy) => {
          composerBusy = busy;
          updateButtonState();
        },
      });
      
      // Initialize button state
      updateButtonState();
      
      // Add click handler for tips link
      const tipsLink = container.find('.js-custom-conversation-tips-link');
      const tipsModal = container.find('.js-custom-conversation-tips-modal');
      
      tipsLink.on('click', function(e) {
        e.preventDefault();
        tipsModal.modal('show');
      });
    }
  }

  showChatTopics() {
    this.destroyComposerTools();
    $('.js-main-chat-option-btn').removeClass('d-none');
    $('.js-continue-conversation-btn').removeClass('d-none');
    this.updateSubOptionsVisibility($('.js-sub-options-container').empty().removeClass('scroll-options is-custom-prompt-view'));
  }

  hideChatTopics() {
    $('.js-main-chat-option-btn').addClass('d-none');
    $('.js-continue-conversation-btn').addClass('d-none');
  }

  hideTopicMenu() {
    this.chatElementContainer.classList.remove('chat-content-w-centered');
    this.chatElementContainer.classList.add('chat-content-w-default');
    this.chatElement.classList.remove('chat-content-centered');
    this.chatElement.classList.add('chat-content-default');
    if (this.chatElement.querySelector('.js-chat-intro-container')) {
      this.chatElement.querySelector('.js-chat-intro-container').remove();
    }
  }
  filterVocabSelection() {
    const requestId = this.vocabFilterRequestId = (this.vocabFilterRequestId || 0) + 1;
    const filters = this.activeFilters;
    const active = Boolean(filters.month || filters.tags.length || filters.last_response !== '');
    $('#filter-btn').toggleClass('btn-primary', active).toggleClass('btn-outline-primary', !active);
    $.ajax({
      url: '/langua/vocabulary/list',
      method: 'GET',
      dataType: 'json',
      data: {
        query: $('.js-vocab-search').val(),
        month: filters.month,
        tag: filters.tags,
        last_response: filters.last_response
      },
      success: (data) => {
        if (requestId !== this.vocabFilterRequestId) return;
        const ids = new Set(data.map(item => String(item.id)));
        $('.vocab-item').each(function() {
          $(this).toggle(ids.has(String($(this).data('id'))));
        });
        $('#flashcard-list .js-vocab-filter-message').remove();
        if (!data.length) {
          $('#flashcard-list').append($('<div class="text-center py-4 js-vocab-filter-message">').text(I18n.t('javascript.chat.no_vocab_found')));
        }
      },
      error: () => {
        if (requestId !== this.vocabFilterRequestId) return;
        $('#flashcard-list .js-vocab-filter-message').remove();
        $('#flashcard-list').append($('<div class="text-danger text-center py-4 js-vocab-filter-message">').text(I18n.t('javascript.chat.error_loading_vocabulary')));
      }
    });
  }

  showVocabSelection(topic, topicCategory, subtopicCategory) {
    const that = this;
    this.vocabFilterRequestId = (this.vocabFilterRequestId || 0) + 1;
    let modal = $('#manual-vocab-modal');
    if (modal.length === 0) {
      modal = $(`
        <div id="manual-vocab-modal" class="modal" tabindex="-1" role="dialog" style="display:block; background: rgba(0,0,0,0.5);">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content" style="padding:20px;">
              <div class="modal-header border-0">
                <div>
                  <h5 class="modal-title h4 mb-1">${I18n.t('javascript.chat.select_vocab')}</h5>
                  <p class="text-muted mb-0">${I18n.t('javascript.chat.select_vocab_instructions')}</p>
                </div>
                <div class="d-flex align-items-center">
                  <span id="vocab-counter" class="mr-3">0/24</span>
                </div>
              </div>
              <div class="modal-body">
                <div class="row mb-3">
                  <div class="col-9">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text bg-light border-right-0">
                          <i class="fa fa-search text-muted"></i>
                        </span>
                      </div>
                      <input type="text" class="form-control border-left-0 js-vocab-search" placeholder="${I18n.t('javascript.vocabulary_selection.search')}">
                    </div>
                  </div>
                  <div class="col-3">
                    <button class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center" id="filter-btn">
                      <i class="fa fa-sliders-h"></i>
                      <span>${I18n.t('javascript.chat.filter')}</span>
                    </button>
                  </div>
                </div>
                <div id="flashcard-list" style="max-height: 400px; overflow-y: auto;"></div>
              </div>
              <div class="modal-footer border-0">
                <div class="row w-100">
                  <div class="col-6">
                    <button type="button" class="btn btn-secondary w-100" id="close-manual-modal">
                      ${I18n.t('javascript.chat.go_back')}
                    </button>
                  </div>
                  <div class="col-6">
                    <button type="button" class="btn btn-primary w-100" id="manual-vocab-submit" disabled>
                      ${I18n.t('javascript.chat.select_n_more', { count: 6 })}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      `);
      $('body').append(modal);

      $('#close-manual-modal').on('click', function () {
        modal.remove();
      });

      // Remove the old vocab item click handler that was causing the flip
      $(document).off('click', '.vocab-item');
      $(document).off('click', '.flip-btn');

      // Add listener ONLY for flip button clicks
      $(document).on('click', '.flip-btn', function (e) {
        e.stopPropagation();
        $(this).closest('.vocab-item').toggleClass('flipped');
      });

      // Add listener for vocab item selection (but not when clicking flip button)
      $(document).on('click', '.vocab-item', function (e) {
        // Don't do anything if we clicked the flip button
        if ($(e.target).closest('.flip-btn').length) {
          return;
        }

        const $item = $(this);
        $item.toggleClass('selected');

        const selectedCount = $('.vocab-item.selected').length;
        $('#vocab-counter').text(`${selectedCount}/24`);

        if (selectedCount > 24) {
          $item.removeClass('selected');
          $('#vocab-counter').text('24/24');
          $('#vocab-counter').addClass('text-danger');
          setTimeout(() => {
            $('#vocab-counter').removeClass('text-danger');
          }, 500);
          return;
        }

        // Enable/disable submit button based on selection count
        const submitBtn = $('#manual-vocab-submit');
        submitBtn.prop('disabled', selectedCount < 6);

        // Update button text
        if (selectedCount < 6) {
          submitBtn.text(I18n.t('javascript.chat.select_n_more', { count: 6 - selectedCount }));
        } else {
          submitBtn.text(I18n.t('javascript.chat.start_chat'));
        }
      });

      // Let the deck's server-side search handle front-only ILIKE wildcards.
      $('.js-vocab-search').on('input', () => {
        clearTimeout(this.vocabSearchTimer);
        this.vocabSearchTimer = setTimeout(() => this.filterVocabSelection(), 250);
      });

      // Add filter button click handler
      $('#filter-btn').on('click', function() {
        showFilterModal();
      });

      // Initialize the instance persistent filters if not already set
      this.activeFilters = { month: '', tags: [], last_response: '', ...this.activeFilters };

      function showFilterModal() {
        const filterModal = $(`
          <div id="vocab-filter-modal" class="modal" tabindex="-1" role="dialog" style="display:block; background: rgba(0,0,0,0.5);">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">${I18n.t('javascript.chat.filter_vocabulary')}</h5>
                  <button type="button" class="close" id="close-filter-modal">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="form-group mb-4">
                    <label for="vocab-status-filter">${I18n.t('javascript.vocabulary_selection.status')}</label>
                    <select class="form-control" id="vocab-status-filter">
                      <option value="">${I18n.t('javascript.vocabulary_selection.all_statuses')}</option>
                      <option value="5">${I18n.t('javascript.vocabulary_selection.learned')}</option>
                      <option value="3">${I18n.t('javascript.vocabulary_selection.almost_learned')}</option>
                      <option value="1">${I18n.t('javascript.vocabulary_selection.difficult')}</option>
                      <option value="0">${I18n.t('javascript.vocabulary_selection.not_practiced')}</option>
                    </select>
                  </div>
                  <div class="form-group mb-4">
                    <label>${I18n.t('javascript.chat.filter_month')}</label>
                    <select class="form-control" id="month-filter">
                      <option value="">${I18n.t('javascript.chat.filter_all_months')}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>${I18n.t('javascript.chat.filter_tags')}</label>
                    <div id="tag-filters" class="d-flex flex-wrap gap-2">
                      <!-- Tags will be populated here -->
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" id="clear-filters">${I18n.t('javascript.chat.clear_filters')}</button>
                  <button type="button" class="btn btn-primary" id="apply-filters">${I18n.t('javascript.chat.apply_filters')}</button>
                </div>
              </div>
            </div>
          </div>
        `);

        $('body').append(filterModal);

        // Keep English month/year values stable; localize only their labels.
        const months = new Set();
        $('.vocab-item').each(function() {
          const month = $(this).data('date');
          if (month) months.add(month);
        });
        const monthSelect = $('#month-filter');
        // Parse "July 2026" by hand: Safari returns Invalid Date for non-ISO strings.
        const monthNames = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
        const monthDate = key => {
          const [name, year] = String(key).trim().split(/\s+/);
          const index = monthNames.indexOf((name || '').toLowerCase());
          return index >= 0 && /^\d{4}$/.test(year) ? new Date(Number(year), index, 1) : null;
        };
        Array.from(months).filter(monthDate).sort((a, b) => monthDate(b) - monthDate(a)).forEach(month => {
          const label = monthDate(month).toLocaleString(document.documentElement.lang || 'en', { month: 'long', year: 'numeric' });
          monthSelect.append($('<option>').val(month).text(label));
        });
        $('#vocab-status-filter').val(that.activeFilters.last_response);

        // Pre-select the persisted month filter
        if (that.activeFilters.month) {
          $('#month-filter').val(that.activeFilters.month);
        }

        // Populate tags
        const tagContainer = $('#tag-filters');
        const allTags = new Set();
        $('.vocab-item').each(function() {
          const tags = $(this).data('tags');
          if (tags) {
            tags.split(',').forEach(tag => {
              if (tag) allTags.add(tag);
            });
          }
        });
        Array.from(allTags).sort().forEach(tag => {
          tagContainer.append(`
            <div class="tag-filter mb-2 mr-2">
              <input type="checkbox" class="tag-checkbox" id="tag-${tag}" value="${tag}">
              <label class="mb-0 ml-1" for="tag-${tag}">${tag}</label>
            </div>
          `);
        });

        // Pre-select persisted tag filters
        $('.tag-checkbox').each(function() {
          const tagVal = $(this).val();
          if (that.activeFilters.tags.includes(tagVal)) {
            $(this).prop('checked', true);
          }
        });

        // Handle filter application
        $('#apply-filters').on('click', function() {
          // Update persisted active filters
          that.activeFilters.month = $('#month-filter').val();
          that.activeFilters.tags = $('.tag-checkbox:checked').map(function() {
            return $(this).val();
          }).get();

          that.activeFilters.last_response = $('#vocab-status-filter').val();
          that.filterVocabSelection();

          // Close filter modal
          $('#vocab-filter-modal').remove();
        });

        // Handle clear filters
        $('#clear-filters').on('click', function() {
          $('#month-filter').val('');
          $('#vocab-status-filter').val('');
          $('.tag-checkbox').prop('checked', false);
          // Clear persisted filters too
          that.activeFilters.month = '';
          that.activeFilters.tags = [];
          that.activeFilters.last_response = '';
          that.filterVocabSelection();
        });

        // Handle close button
        $('#close-filter-modal').on('click', function() {
          $('#vocab-filter-modal').remove();
        });

        // Add styles for the filter modal
        $('head').append(`
          <style>
            #vocab-filter-modal .gap-2 {
              gap: 0.5rem;
            }
            .tag-filter {
              display: inline-flex;
              align-items: center;
              padding: 4px 8px;
              background: rgba(0,0,0,0.05);
              border-radius: 4px;
            }
            .dark-mode .tag-filter {
              background: rgba(255,255,255,0.1);
            }
          </style>
        `);
      }
    }

    function loadVocabulary() {
      const flashcardList = $('#flashcard-list');
      flashcardList.empty();

      $.ajax({
        url: '/langua/vocabulary/list',
        method: 'GET',
        dataType: 'json',
        success: function (data) {
          if (data.length === 0) {
            flashcardList.append(`<div class="text-center py-4">${I18n.t('javascript.chat.no_vocab_found')} </div>`);
            return;
          }

          // Filter out items with "sentence" tag
          const filteredData = data.filter(flashcard => {
            const tags = Array.isArray(flashcard.tags) ? flashcard.tags : [];
            return !tags.includes('sentence');
          });

          if (filteredData.length === 0) {
            flashcardList.append(`<div class="text-center py-4">${I18n.t('javascript.chat.no_vocab_found')} </div>`);
            return;
          }

          filteredData.forEach(function (flashcard) {
            const listItem = $(vocabListItemHtml(flashcard));
            flashcardList.append(listItem);
          });
          if ($('.js-vocab-search').val() || that.activeFilters.month || that.activeFilters.tags.length || that.activeFilters.last_response !== '') {
            that.filterVocabSelection();
          }
        },
        error: function () {
          flashcardList.append(`<div class="text-danger text-center py-4">${I18n.t('javascript.chat.error_loading_vocabulary')}</div>`);
        }
      });
    }

    // Initial load
    loadVocabulary();

    // Update submit handler to use selected class instead of checkboxes
    $('#manual-vocab-submit').off('click').on('click', function (e) {
      e.preventDefault();
      // Card ids: the server reads the cards (VocabPractice::StartChat), so a
      // phrase with a comma in it stays one phrase.
      let selected = [];
      $('.vocab-item.selected').each(function () {
        selected.push(this.dataset.id);
      });

      if (selected.length < 6) {
        return;
      }

      $('#chat_form_selected_card_ids').val(selected.join(','));
      $('#js-chat-topic').val(topic);
      $('#js-chat-topic-category').val(topicCategory);
      $('#js-chat-subtopic-category').val(subtopicCategory);

      modal.remove();
      $('#new-chat-form').submit();
    });

    // Update the styles
    $('head').append(`
      <style>
        .vocab-card {
          position: relative;
          transform-style: preserve-3d;
          transition: transform 0.6s;
          height: 100%;
          cursor: pointer;
        }
        
        .vocab-item.flipped .vocab-card {
          transform: rotateX(180deg);
        }
        
        .card-front,
        .card-back {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          background: rgba(249, 250, 251, 0.5);
          border-radius: 0.5rem;
          border: 2px solid transparent;
          transition: border-color 0.2s ease;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }
        
        .card-back {
          transform: rotateX(180deg);
        }
        
        .vocab-item {
          height: 60px;
          perspective: 1000px;
        }
        
        .vocab-item.selected .card-front,
        .vocab-item.selected .card-back {
          border-color: #FC5D5D;
        }
        
        .dark-mode .card-front,
        .dark-mode .card-back {
          background: rgba(55, 65, 81, 0.5);
          color: white;
        }

        .flip-btn {
          transition: transform 0.2s ease;
          z-index: 1;
          padding: 8px !important;
          font-size: 1.2rem;
        }

        .flip-btn:hover {
          transform: scale(1.1);
        }

        .vocab-text {
          font-size: 1rem;
          line-height: 1.5;
        }

        .vocab-tags {
          display: flex;
          gap: 4px;
          justify-content: flex-end;
        }

        .vocab-tag {
          font-size: 0.75rem;
          padding: 2px 6px;
          background: rgba(0, 0, 0, 0.05);
          border-radius: 4px;
          color: #666;
          white-space: nowrap;
        }

        .dark-mode .vocab-tag {
          background: rgba(255, 255, 255, 0.1);
          color: #ccc;
        }

        #manual-vocab-modal .modal-content {
          max-height: 90vh;
          overflow-y: auto;
        }

        /* Hide tags on smaller screens */
        @media (max-width: 768px) {
          .vocab-tags {
            display: none;
          }

          #filter-btn {
            padding: 0.375rem !important;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
          }

          #filter-btn i {
            margin: 0 !important;
            padding: 0 !important;
          }

          #filter-btn span {
            line-height: 1;
          }
        }
      </style>
    `);
  }
}

export default ChatTopicService;
